module.exports = __webpack_public_path__ + "media/images/White Round Edge Rectangle-4e33e80f3a5a35fe75a9b16744dba5c6.svg";